"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureFlagContext = void 0;
const react_1 = __importStar(require("react"));
const useFeatureFlag_1 = __importStar(require("../../hooks/useFeatureFlag"));
const segment_1 = require("../../utils/development/segment");
const useAuthContext_1 = __importDefault(require("../Auth/useAuthContext"));
const defaultTransactionState = [
    useFeatureFlag_1.DEFAULT_FEATURE_FLAG,
    {
        loading: false,
        error: null,
        time: 0,
        version: 0,
        loaded: false,
        set: () => null,
        reload: () => null,
        isEnabled: () => false,
        getVariant: () => null,
        getVariantName: () => null,
        getVariantValue: () => null,
    },
];
exports.FeatureFlagContext = (0, react_1.createContext)(defaultTransactionState);
exports.default = react_1.default.memo(function FeatureFlagProvider(props) {
    const [userId] = (0, useAuthContext_1.default)();
    const options = (0, react_1.useMemo)(() => {
        if (!props.endpoint && !props.applicationName) {
            return {};
        }
        const result = {};
        if (props.applicationName) {
            result.applicationName = props.applicationName;
        }
        else {
            const endpoint = new URL(props.endpoint);
            const applicationName = endpoint.pathname.slice(1, -5);
            if (applicationName) {
                result.applicationName = applicationName;
            }
        }
        if (result.applicationName) {
            if (props.debug) {
                result.debug = props.debug;
            }
            if (props.featureFlagsUrl) {
                result.featureFlagsUrl = props.featureFlagsUrl;
            }
            if (userId) {
                result.userId = userId;
            }
        }
        return result;
    }, [
        props.endpoint,
        props.applicationName,
        props.debug,
        props.featureFlagsUrl,
        userId,
    ]);
    const ff = (0, useFeatureFlag_1.default)(options);
    (0, react_1.useEffect)(() => {
        const [features] = ff;
        if (features !== useFeatureFlag_1.DEFAULT_FEATURE_FLAG) {
            (0, segment_1.track)('feature_flags', { featureFlags: features.list() });
        }
    }, [ff]);
    return (react_1.default.createElement(exports.FeatureFlagContext.Provider, { value: ff }, props.children));
});
